"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'Regular Decision (RD)',
    'Early Decision 1 (ED1)',
    'Early Decision 2 (ED2)',
    'Early Action (EA)',
    'Early Decision (EU)',
    'Regular Deadline (EU)',
    'Single-choice early action (SCEA)',
    'Rolling',
    'Transfer',
    'UK1',
    'UK2',
    'Other',
];
//# sourceMappingURL=applicationRounds.js.map